module.exports = __webpack_public_path__ + "img/category_4.d953d1c0.svg";